//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BomInformation from "./bomInformation";
import BomFabirc from "./bomFabirc";
export default {
  name: 'BulkBom',
  components: {
    BomInformation: BomInformation,
    BomFabirc: BomFabirc
  },
  props: {
    materialColorDataVoList: {
      type: Array,
      required: true,
      default: null
    }
  },
  data: function data() {
    return {
      bomActive: '0'
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};